import Section from "components/molecules/section";
import { BannerSlider } from "components/organisms";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

import "./styles.scss";

const PoliticasPrivacidadEs = () => {
  const { t } = useTranslation();

  const banner_data_centrado = [
    {
      id: 1,
      titulo: t("privacyPolicy.privacyPolicy"),
      subtitulo: "",
      color_fondo_logo: "rgba(62, 145, 41, 1)",
      img_desktop: {
        name: "banner-politicas-privacidad",
        path: "https://s3.us-east-1.amazonaws.com/ca-webprod/media/c9c6116d-b559-445b-b8c3-3b6dd38656a2.jpg",
        width: 1440,
        height: 400,
        size: 794666,
        title: "Banner Políticas web de privacidad",
        alt: "Banner Políticas web de privacidad",
        description: null,
        caption: "Banner Políticas web de privacidad",
      },
      img_mobile: [],
      descuento: "",
      descripcion_boton: "",
      redireccion_boton: "",
      img_logos: [],
      tipo_banner: {
        id: 1,
        titulo: "landings",
      },
    },
  ];

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <BannerSlider data={banner_data_centrado} gradiente />
      <Section>
        <div className="politicas_privacidad politicas_privacidad-element">
          <div className="politicas_privacidad__container">
            <p>{t("webPrivacy.text1")}</p>
            <p>{t("webPrivacy.text2")}</p>
            <br />
            <h1>{t("webPrivacy.title1")}</h1>
            <p>{t("webPrivacy.text3")}</p>
            <p>{t("webPrivacy.text4")}</p>
            <h1>{t("webPrivacy.title2")}</h1>
            <p>{t("webPrivacy.text5")}</p>
            <ul>
              <li>{t("webPrivacy.ul1.item1")}</li>
              <li>{t("webPrivacy.ul1.item2")}</li>
              <li>{t("webPrivacy.ul1.item3")}</li>
            </ul>
            <br />
            <h1>{t("webPrivacy.title3")}</h1>
            <p>{t("webPrivacy.text6")}</p>
            <br />
            <h1>{t("webPrivacy.title4")}</h1>
            <p>{t("webPrivacy.text7")}</p>
            <p>{t("webPrivacy.text8")}</p>
            <p>{t("webPrivacy.text9")}</p>
            <p className="text-bold">{t("webPrivacy.text10")}</p>
            <p>{t("webPrivacy.text11")}</p>
            <p>{t("webPrivacy.text12")}</p>
            <p>{t("webPrivacy.text13")}</p>
            <p>{t("webPrivacy.text14")}</p>
            <p>{t("webPrivacy.text15")}</p>
            <p>{t("webPrivacy.text16")}</p>
            <p className="text-bold">{t("webPrivacy.text17")}</p>
            <p>{t("webPrivacy.text18")}</p>
            <p>{t("webPrivacy.text19")}</p>
            <p>{t("webPrivacy.text20")}</p>
            <p>{t("webPrivacy.text21")}</p>
            <p>{t("webPrivacy.text22")}</p>
            <p>{t("webPrivacy.text23")}</p>
            <p className="text-bold">{t("webPrivacy.text24")}</p>
            <p>{t("webPrivacy.text25")}</p>
            <p>{t("webPrivacy.text26")}</p>
            <p>{t("webPrivacy.text27")}</p>
            <p>{t("webPrivacy.text28")}</p>
            <p>{t("webPrivacy.text29")}</p>
            <p>{t("webPrivacy.text30")}</p>
            <p>{t("webPrivacy.text31")}</p>
            <p>
              {t('webPrivacy.text32.text1')}
              {" "}
              <a href={t('webPrivacy.text32.link')}>
                {t('webPrivacy.text32.link')}
              </a>
              {t('webPrivacy.text32.text2')}
            </p>
            <p>
              {t('webPrivacy.text33.text1')}
              <a href={t('webPrivacy.text33.link')}>
                {t('webPrivacy.text33.text2')}
              </a>
            </p>
            <p>{t("webPrivacy.text34")}</p>
            <p>{t("webPrivacy.text35")}</p>
            <p>{t("webPrivacy.text36")}</p>
            <br />
            <h1>{t('webPrivacy.title5')}</h1>
            <p>
              {t('webPrivacy.text37')}
            </p>
            <br />
            <h1>{t('webPrivacy.title6')}</h1>
            <p>
              {t('webPrivacy.text38')}
            </p>
            <p>
              {t('webPrivacy.text39.text1')}
              {" "}
              <a href={t('webPrivacy.text39.link')}>
                {t('webPrivacy.text39.text2')}
              </a>
            </p>
            <p>
            {t('webPrivacy.text40')}
            </p>
            <p>
            {t('webPrivacy.text41')}
            </p>
            <br />
            <h1>{t('webPrivacy.title7')}</h1>
            <p>
              {t('webPrivacy.text42.text1')}{" "}
              <a href={t('webPrivacy.text42.link')}>
                {t('webPrivacy.text42.text2')}
              </a>
            </p>
            <p>
            {t('webPrivacy.text43')}
            </p>
            <br />
            <h1>{t('webPrivacy.title8')}</h1>
            <p>
            {t('webPrivacy.text44')}
            </p>
            <br />
            <h1>{t('webPrivacy.title9')}</h1>
            <p>
            {t('webPrivacy.text45')}
            </p>
            <br />
            <h1>{t('webPrivacy.title10')}</h1>
            <p>
            {t('webPrivacy.text46')}
            </p>
            <p>
            {t('webPrivacy.text47')}
            </p>
            <br />
            <h1>{t('webPrivacy.title11')}</h1>
            <p>
              {t('webPrivacy.text48.text1')}
              {" "}
              <a href={`mailto:${('webPrivacy.text48.link')}`}>
              {t('webPrivacy.text48.text2')}
              </a>
            </p>
            <br />
            <h1>{t('webPrivacy.title12')}</h1>
            <p>
              {t('webPrivacy.text49')}
            </p>
          </div>
        </div>
      </Section>
    </>
  );
};

export default PoliticasPrivacidadEs;
